export default {
      id: "icon--triangle-usage",
      viewBox: "0 0 28.082 24.998",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--triangle-usage",
      toString: function () {
        return this.url;
      }
    }